{
	"0": {
		"title": { "Looking for the archive?": "Well here it is! With # puzzles to play…" },
		"message": [
			"Get cracking!",
			"Crack on!",
			"Tuck in!",
			"Time to knuckle down.",
			"No use standing about!",
			"Shall we get these wheels in motion?"
		]
	},
	"25": {
		"title": { "Play more from before": "Presenting the archive! With # puzzles to play…" },
		"message": ["Warming up!", "Taking your first steps!", "Onwards and upwards!"]
	},
	"50": {
		"title": { "One More?": "Continue with the archive? With # puzzles to play…" },
		"message": ["You go Glen Coco!", "Great job Bob, keep going!"]
	},
	"75": {
		"title": { "One More?": "Continue with the archive? With # puzzles to play…" },
		"message": ["Yay!", "Glorious!", "Over halfway!"]
	},
	"90": {
		"title": {
			"Final Hurdles!": "We'll make a champion out of you yet! Finish all # puzzles…"
		},
		"message": ["So Close!", "You can do it!", "Home stretch!"]
	},
	"99": {
		"title": {
			"You're so close!": "Perhaps today you'll conquer the archive? Finish all # puzzles…"
		},
		"message": [
			"The final hurdle!",
			"One last push!",
			"Fantastic!",
			"What a smashing little pumpkin you are!"
		]
	},
	"100": {
		"title": {
			"Archived Brilliance!": "You know it all too well! That's # puzzles completed…"
		},
		"message": [
			"Why not once more?",
			"Marvellous!",
			"Pat on the back!",
			"What a sight to behold.",
			"Colour me impressed!",
			"You did it!"
		]
	}
}
